import PostitioningDeviceInfoChangeInstallerModal from './postitioning-device-info-change-installer-modal.vue'
export default PostitioningDeviceInfoChangeInstallerModal
